import React, { Suspense } from 'react';
import { createRoot } from 'react-dom/client';
import { LazyComponent } from "./LazyComponent";
import "./LazyComponent.scss"

import SecondaryNav from '../Blocks/secondaryNav/SecondaryNav';
const ContentAreaBlock = React.lazy(() => import('../Blocks/ContentAreaBlock'));
const HTMLBlock = React.lazy(() => import('../Blocks/HtmlBlock'));
const VisualSectionBlock = React.lazy(() => import('../Components/VisualSectionBlock/VisualSectionBlock'));
const PerformanceHistoryBlock = React.lazy(() => import('../Components/PerformanceHistoryBlock/PerformanceHistoryBlock'));
const HypotheticalChartBlock = React.lazy(() => import('../Components/HypotheticalChartBlock/HypotheticalChartBlock'));
const HoldingsWeightingsChartBlock = React.lazy(() => import('../Components/HoldingsWeightingsChartblock/HoldingsWeightingsChartBlock'))

//Bots
const isCrawler = /bot|googlebot|crawler|spider|robot|crawling/i.test(navigator.userAgent);

const blockTypes = [
    {
        name: "ContentAreaBlock",
        tagName: "ve-contentareablock",
        component: ContentAreaBlock,
        LoadImmediately: false
    },
    {
        name: "HTMLBlock",
        tagName: "ve-htmlblock",
        component: HTMLBlock,
        LoadImmediately: false,
    },
    {
        name: "VisualSectionBlock",
        tagName: "ve-visualsectionucitsblock",
        component: VisualSectionBlock,
        LoadImmediately: false,
    },
    {
        name: "SecondaryNav",
        tagName: "ve-fundpagesecondarynav",
        component: SecondaryNav,
        LoadImmediately: true
    },
    {
        name: "HypotheticalChartBlock",
        tagName: "ve-hypotheticalchartblock",
        component: HypotheticalChartBlock,
        LoadImmediately: false,
        IgnoreForCrawlers: true
    },
    {
        name: "PerformanceHistoryBlock",
        tagName: "ve-performancehistoryblock",
        component: PerformanceHistoryBlock,
        LoadImmediately: false,
    },
    {
        name: "HoldindsWeightingsChartBlock",
        tagName: "ve-holdingsweightingschartblock",
        component: HoldingsWeightingsChartBlock,
        LoadImmediately: false,
        IgnoreForCrawlers: true
    },
]

export function processMarkup(rootElem = document) {
    //If it is a crawler, remove the blocks that are too slow to load.
    let blockTypesToRender = blockTypes;
    if (isCrawler) {
        blockTypesToRender = blockTypes.filter(block => {
            return typeof (block.IgnoreForCrawlers) == "undefined" || block.IgnoreForCrawlers == false;
        })
    }

    for (const block of blockTypesToRender) {
        var containers = rootElem.getElementsByTagName(block.tagName)
        if (block.template != null) {
            containers = Array.from(containers).filter(x => x.dataset.template == block.template)
        }
        for (const container of containers) {
            const root = createRoot(container);
            const { component, LoadImmediately } = block;
            root.render(
                <Suspense fallback={<div className="component-loading">Loading...</div>}>
                    <LazyComponent component={component} rootElement={container} loadImmediately={LoadImmediately} />
                </Suspense>
            );
        }
    }
}